import Alpine from 'alpinejs';

Alpine.data('eventsArchive', () => ({
  filterOpen: false,
  isDesktop: window.innerWidth >= 1024,
  openGroup: null,
  filters: {
    day: [],
    price: [],
    age: [],
    venue: [],
    type: [],
  },

  get activeFilterCount() {
    return Object.values(this.filters).reduce((sum, arr) => sum + arr.length, 0);
  },

  get hasActiveFilters() {
    return this.activeFilterCount > 0;
  },

  noResults: false,

  toggleFilter(category, value) {
    const idx = this.filters[category].indexOf(value);
    if (idx === -1) {
      this.filters[category].push(value);
    } else {
      this.filters[category].splice(idx, 1);
    }
    this.applyFilters();
  },

  selectFilter(category, value) {
    if (this.filters[category].includes(value)) {
      this.filters[category] = [];
    } else {
      this.filters[category] = [value];
    }
    this.applyFilters();
  },

  clearFilters(category) {
    if (category) {
      this.filters[category] = [];
    } else {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = [];
      });
    }
    this.applyFilters();
  },

  // Map internal filter keys to URL param names
  // 'day' is a reserved WordPress query var, so we use 'event_day' in the URL
  urlKeyMap: {
    day: 'event_day',
  },

  syncURL() {
    const params = new URLSearchParams();
    Object.entries(this.filters).forEach(([key, values]) => {
      if (values.length) {
        params.set(this.urlKeyMap[key] || key, values.join(','));
      }
    });
    const query = params.toString();
    const url = `${window.location.pathname}${query ? '?' + query : ''}`;
    history.replaceState(null, '', url);
  },

  applyFilters() {
    const cards = this.$root.querySelectorAll('.c-events-archive__card-wrapper');
    const hasFilters = this.hasActiveFilters;

    cards.forEach(card => {
      if (!hasFilters) {
        card.classList.remove('is-hidden');
        return;
      }

      const match = [
        { key: 'day', attr: 'day' },
        { key: 'price', attr: 'price' },
        { key: 'age', attr: 'age' },
        { key: 'venue', attr: 'venue' },
        { key: 'type', attr: 'type' },
      ].every(({ key, attr }) => {
        const active = this.filters[key];
        if (active.length === 0) return true;
        if (key === 'day') {
          const cardDays = (card.dataset.day || '').split(',');
          return active.some(d => cardDays.includes(d));
        }
        return active.includes(card.dataset[attr] || '');
      });

      card.classList.toggle('is-hidden', !match);
    });

    const visibleCards = this.$root.querySelectorAll('.c-events-archive__card-wrapper:not(.is-hidden)');
    this.noResults = hasFilters && visibleCards.length === 0;

    this.syncURL();
  },

  init() {
    this.isDesktop = window.innerWidth >= 1024;
    this.filterOpen = this.isDesktop;

    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 1024;
    });

    // Hydrate filters from URL query params
    const params = new URLSearchParams(window.location.search);
    const validKeys = Object.keys(this.filters);
    let hasURLFilters = false;

    validKeys.forEach(key => {
      const value = params.get(this.urlKeyMap[key] || key);
      if (value) {
        this.filters[key] = value.split(',').map(v => v.trim());
        hasURLFilters = true;
      }
    });

    if (hasURLFilters) {
      this.applyFilters();
    }
  }
}));
